import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=af1f21de"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=af1f21de&lang=scss&module=true"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./Overlay.vue?vue&type=style&index=0&id=af1f21de&lang=scss&module=true"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./Overlay.vue?vue&type=style&index=0&id=af1f21de&lang=scss&module=true")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js").rerender("af1f21de")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af1f21de')) {
      api.createRecord('af1f21de', component.options)
    } else {
      api.reload('af1f21de', component.options)
    }
    module.hot.accept("./Overlay.vue?vue&type=template&id=af1f21de", function () {
      api.rerender('af1f21de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overlay/Overlay.vue"
export default component.exports